import React from "react";
import I18n from "../../I18n";
import styles from "./FileMessageSalesSubmissionInformation.module.sass";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import { stringifyFilter } from "colbi_web_ui/lib/utils";
import { Link } from "react-router-dom";

const FileMessageSalesSubmissionInformation = (props) => {
    const { mergeRepository, modules } = props;
    const { params } = useGlobalValue();
    const { projectId, fiscalYear, importId, locale } = params;
    let { status, files, fileType } = mergeRepository || {};

    const messageToDisplay = {
        1: "All files are Submitted",
        2: "Missing some files to submit",
        3: "Submission is on going",
    };
    const colorToDisplay = {
        1: "message-success",
        2: "message-missing",
        3: "message-warning",
    };

    let customUrl = undefined;
    if (status && status === 2 && files && files.length) {
        const localeToUse = locale || "en";
        customUrl = `/${localeToUse}/${projectId}/${fiscalYear}/${importId}/repository/folders/${fileType}/?filter=${stringifyFilter(
            [
                {
                    column: "ID",
                    filters: files.map((id) => {
                        return { value: `${id}` };
                    }),
                },
            ],
        )}`;
    }
    const checkSubmissionModule = (modules || []).includes("submission_file");
    return (
        <div>
            {checkSubmissionModule && importId === "full" && status ? (
                <div className={`${styles["message"]} ${styles[`${colorToDisplay[status]}`]}`}>
                    <p>{I18n.translate`${messageToDisplay[status] || "N/A"}`}</p>
                    {customUrl ? (
                        <Link to={customUrl}>
                            <small>{I18n.translate`See Missing Files`}</small>
                        </Link>
                    ) : null}
                </div>
            ) : null}
        </div>
    );
};

export default FileMessageSalesSubmissionInformation;
